import API from 'js/lib/api';

import inServerContext from 'bundles/ssr/util/inServerContext';

import type { UserPermissions } from './types';

export interface PermissionsNetworkResponse {
  elements: Array<{
    id: string;
    permissions: UserPermissions;
  }>;
}

class MemoizedPermissionsNetworkRequest {
  private store: Record<string, Promise<PermissionsNetworkResponse>> = {};

  private _storeKey(userId: string, courseSlug: string): string {
    return `${userId}~${courseSlug}`;
  }

  private async _fetchPermissionsFromNetwork(userId: string, courseSlug: string): Promise<PermissionsNetworkResponse> {
    const authoringUserCoursePermissionsAPI = API(`/api/authoringUserCoursePermissions.v1/`, {
      type: 'rest',
    });

    const result = await authoringUserCoursePermissionsAPI.get(`${userId}~${courseSlug}`);

    return result;
  }

  /** Get from store or fetch fresh */
  async getPermissions(userId: string, courseSlug: string) {
    // Do not perform any caching when in SSR mode
    if (inServerContext) {
      return this._fetchPermissionsFromNetwork(userId, courseSlug);
    }

    const key = this._storeKey(userId, courseSlug);
    if (this.store[key] === undefined) {
      this.store[key] = this._fetchPermissionsFromNetwork(userId, courseSlug);
    }

    return this.store[key];
  }
}

export default MemoizedPermissionsNetworkRequest;
